// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('p2UpdateTableEdit', {
//         templateUrl: 'views/components/views/p2UpdateTableEdit/p2UpdateTableEdit.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         bindings: {
//             p2UpdateTableKeyno: '<?',
//             onSave: '&'
//         },
//         controller: ['$stateParams', 'stateService', 'p2UpdateTableEditService', 'layoutService', function ($stateParams, stateService, p2UpdateTableEditService, layoutService) {
//             const vm = this;
//             let p2UpdateTableKeyno = vm?.p2UpdateTableKeyno ?? $stateParams.p2_updatetable_keyno;
//             let tabletSize = layoutService.getMediaQueries().tablet;

//             vm.model = {
//                 tabletSize: tabletSize,
//                 edit: {
//                     sync_data: '1'
//                 },
//                 lockedSave: false
//             };

//             let loadEdit = function () {
//                 p2UpdateTableEditService.getUpdateTable({ p2_updatetable_keyno: p2UpdateTableKeyno }).then(function (info) {
//                     angular.copy(info[0], vm.model.edit);
//                 });
//             };
            
//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 p2UpdateTableEditService.saveObj(vm.model.edit).then(function () {
//                     vm.model.lockedSave = false;

//                     if (angular.isFunction(vm.onSave) && tabletSize.matches === true) {
//                         vm.onSave();
//                     } else {
//                         stateService.back();
//                     }
//                 }, function () {
//                     vm.model.lockedSave = false;
//                 });
//             };

//             vm.$onInit = function () {
//                 //loadEdit();
//             };

//             vm.$onChanges = function (changes) {
//                 if (changes?.p2UpdateTableKeyno?.currentValue) {
//                     p2UpdateTableKeyno = changes.p2UpdateTableKeyno.currentValue;
//                 }

//                 if (p2UpdateTableKeyno) loadEdit();
//             };
//         }]
//     });
// })();
